import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { environment } from '@env/environment';
import { PromoCampaignConfig } from '../_models/promo-campaign-config.model';
import { Page } from '@interfaces/page';
import { SortingPagingData } from '@helpers/sorting-paging-data';

const apiServerUrl           = environment.apiBaseURL;
const baseUrl                = apiServerUrl + '/promo-campaign-config';
const findByIdUrl            = baseUrl + '/{id}';
const saveUrl                = baseUrl;
const findPageableUrl        = baseUrl + '/pageable';
const countPageableUrl       = baseUrl + '/pageable-count';

@Injectable({
  providedIn: 'root'
})
export class PromoCampaignConfigService {

  constructor(private http: HttpClient) { }

  public findById(id: number): Observable<PromoCampaignConfig> {
    return this.http.get<PromoCampaignConfig>(findByIdUrl.replace('{id}', `${id}`));
  }

  public save(config: PromoCampaignConfig): Observable<number> {
    return this.http.post<number>(saveUrl, config);
  }

  public pageable(sortingPaging: SortingPagingData, filters: any): Observable<[Page<PromoCampaignConfig>, number]> {
    return forkJoin([
      this.findPageable(sortingPaging, filters),
      this.countAll(filters)
    ]);
  }

  public findPageable(sortingPaging: SortingPagingData, filters: any): Observable<Page<PromoCampaignConfig>> {
    let params = new HttpParams()
      .set('page', sortingPaging.pageNumber.toString())
      .set('pageSize', sortingPaging.pageSize.toString());

    if (sortingPaging.sortBy) params = params.set('sortBy', sortingPaging.sortBy);
    if (sortingPaging.sortAsc != null) params = params.set('sortAsc', sortingPaging.sortAsc.toString());
    if (filters?.serviceName) params = params.set('serviceName', filters.serviceName);
    if (filters?.hasTrigger != null) params = params.set('hasTrigger', filters.hasTrigger.toString());
    if (filters?.hasPromoPrice != null) params = params.set('hasPromoPrice', filters.hasPromoPrice.toString());
    if (filters?.isActive != null) params = params.set('isActive', filters.isActive.toString());

    return this.http.get<Page<PromoCampaignConfig>>(findPageableUrl, { params });
  }

  public countAll(filters: any): Observable<number> {
    let params = new HttpParams();

    if (filters?.serviceName) params = params.set('serviceName', filters.serviceName);
    if (filters?.hasTrigger != null) params = params.set('hasTrigger', filters.hasTrigger.toString());
    if (filters?.hasPromoPrice != null) params = params.set('hasPromoPrice', filters.hasPromoPrice.toString());
    if (filters?.isActive != null) params = params.set('isActive', filters.isActive.toString());

    return this.http.get<number>(countPageableUrl, { params });
  }
}
